import { ONBOARDING } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  gridState: {
    sortBy: [{ id: 'onboarded', desc: true, find: () => {}, findIndex: () => {} }],
  },
  controlledGridState: {
    sortBy: [{ id: 'onboarded', desc: true, find: () => {}, findIndex: () => {} }],
  },
  selectedGridRows: [],
  maxGridRowSelection: 1,
  selectedDatasetIds: [],
  onboardingsPage: 0,
  onboardingsPages: 0,
  onboardingsPerPage: 10,
  onboardingsTotal: 0,
  onboardings: [],
  refreshes: [],
  refreshId: null,
  fetchOnboardingsStatus: null,
  fetchOnboardingsError: null,
  clientOnboardingConfig: {},
  fetchClientOnboardingConfigStatus: null,
  fetchClientOnboardingConfigError: null,
  uploadFile: null,
  getUploadFileStatus: null,
  getUploadFileError: null,
  triggerDetWorkflowStatus: null,
  triggerDetWorkflowError: null,
  approveDetWorkflowStatus: null,
  approveDetWorkflowError: null,
  confirmDetWorkflowStatus: null,
  confirmDetWorkflowError: null,
  files: [],
  dataset: null,
  datasetName: null,
  datasetTag: null,
  onboardingType: null,
  uploadFileStatus: null,
  uploadFileError: null,
  progress: [],
  bucket: null,
  key: null,
  client: null,
  fetchClientByTenantStatus: null,
  fetchClientByTenantError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ONBOARDING.FETCH_CLIENT_BY_TENANT:
      return {
        ...state,
        fetchClientByTenantStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.FETCH_CLIENT_BY_TENANT_SUCCEEDED:
      return {
        ...state,
        client: action.payload,
        fetchClientByTenantStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.FETCH_CLIENT_BY_TENANT_FAILED:
      return {
        ...state,
        fetchClientByTenantStatus: CONSTANTS.API.FAILED,
        fetchClientByTenantError: action.payload,
      };
    case ONBOARDING.APPROVE_DET_WORKFLOW:
      return {
        ...state,
        approveDetWorkflowStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.APPROVE_DET_WORKFLOW_SUCCEEDED:
      return {
        ...state,
        approveDetWorkflowStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.APPROVE_DET_WORKFLOW_FAILED:
      return {
        ...state,
        approveDetWorkflowStatus: CONSTANTS.API.FAILED,
        approveDetWorkflowError: action.payload,
      };
    case ONBOARDING.CONFIRM_DET_WORKFLOW:
      return {
        ...state,
        confirmDetWorkflowStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.CONFIRM_DET_WORKFLOW_SUCCEEDED:
      return {
        ...state,
        confirmDetWorkflowStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.CONFIRM_DET_WORKFLOW_FAILED:
      return {
        ...state,
        confirmDetWorkflowStatus: CONSTANTS.API.FAILED,
        confirmDetWorkflowError: action.payload,
      };
    case ONBOARDING.TRIGGER_DET_WORKFLOW:
      return {
        ...state,
        triggerDetWorkflowStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.TRIGGER_DET_WORKFLOW_SUCCEEDED:
      return {
        ...state,
        triggerDetWorkflowStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.TRIGGER_DET_WORKFLOW_FAILED:
      return {
        ...state,
        triggerDetWorkflowStatus: CONSTANTS.API.FAILED,
        triggerDetWorkflowError: action.payload,
      };
    case ONBOARDING.SET_REFRESH_ID:
      return {
        ...state,
        refreshId: action.payload,
      };
    case ONBOARDING.FETCH_REFRESHES:
      return {
        ...state,
        fetchRefreshesStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.FETCH_REFRESHES_FAILED:
      return {
        ...state,
        fetchRefreshesStatus: CONSTANTS.API.FAILED,
        error: action.payload,
      };
    case ONBOARDING.FETCH_REFRESHES_SUCCEEDED:
      return {
        ...state,
        refreshes: action.payload,
        fetchRefreshesStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.SET_DATASET_NAME:
      return {
        ...state,
        datasetName: action.payload,
      };
    case ONBOARDING.SET_DATASET_TAG:
      return {
        ...state,
        datasetTag: action.payload,
      };
    case ONBOARDING.SET_ONBOARDING_TYPE:
      return {
        ...state,
        onboardingType: action.payload,
      };
    case ONBOARDING.FETCH_ONBOARDINGS:
      return {
        ...state,
        fetchOnboardingsStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.FETCH_ONBOARDINGS_SUCCEEDED:
      return {
        ...state,
        onboardings: action.payload.items,
        onboardingsPage: action.payload.page,
        onboardingsPages: action.payload.pages,
        onboardingsPerPage: action.payload.per_page,
        onboardingsTotal: action.payload.total,
        fetchOnboardingsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.SET_GRID_STATE:
      return {
        ...state,
        gridState: action.payload,
        controlledGridState: {},
      };
    case ONBOARDING.SET_SELECTED_GRID_ROWS:
      return {
        ...state,
        selectedGridRows: action.payload,
        controlledGridState: {
          ...state.controlledGridState,
          selectedRowIds: Object.fromEntries(action.payload.map(({ id }) => [id, true])),
        },
      };
    case ONBOARDING.FETCH_ONBOARDINGS_FAILED:
      return {
        ...state,
        fetchOnboardingsStatus: CONSTANTS.API.FAILED,
        fetchOnboardingsError: action.payload,
      };
    case ONBOARDING.FETCH_CLIENT_ONB_CONFIG:
      return {
        ...state,
        fetchClientOnboardingConfigStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.FETCH_CLIENT_ONB_CONFIG_SUCCEEDED:
      return {
        ...state,
        clientOnboardingConfig: action.payload,
        fetchClientOnboardingConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.FETCH_CLIENT_ONB_CONFIG_FAILED:
      return {
        ...state,
        fetchClientOnboardingConfigStatus: CONSTANTS.API.FAILED,
      };
    case ONBOARDING.GET_CUF:
      return {
        ...state,
        getUploadFileStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.GET_CUF_SUCCEEDED:
      return {
        ...state,
        uploadFile: action.payload,
        getUploadFileStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.GET_CUF_FAILED:
      return {
        ...state,
        getUploadFileStatus: CONSTANTS.API.FAILED,
        getUploadFileError: action.payload,
      };
    case ONBOARDING.GET_ONBOARDING:
      return {
        ...state,
        getOnboardingStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.GET_ONBOARDING_SUCCEEDED:
      return {
        ...state,
        onboarding: action.payload,
        getOnboardingStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.GET_ONBOARDING_FAILED:
      return {
        ...state,
        getOnboardingStatus: CONSTANTS.API.FAILED,
        getOnboardingError: action.payload,
      };
    case ONBOARDING.GET_DATASET:
      return {
        ...state,
        getDatasetStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.GET_DATASET_SUCCEEDED:
      return {
        ...state,
        dataset: action.payload,
        getDatasetStatus: CONSTANTS.API.SUCCEEDED,
      };
    case ONBOARDING.GET_DATASET_FAILED:
      return {
        ...state,
        getDatasetStatus: CONSTANTS.API.FAILED,
        getDatasetError: action.payload,
      };
    case ONBOARDING.STAGE_FILES:
      return {
        ...state,
        files: action.payload,
        progress: Array.from(action.payload, () => 0),
      };
    case ONBOARDING.UPLOAD_FILES:
      return {
        ...state,
        uploadFileStatus: CONSTANTS.API.STARTED,
      };
    case ONBOARDING.UPLOAD_FILES_SUCCEEDED:
      return {
        ...state,
        uploadFileStatus: CONSTANTS.API.SUCCEEDED,
        bucket: action.payload.bucket,
        key: action.payload.key,
      };
    case ONBOARDING.UPLOAD_FILES_FAILED:
      return {
        ...state,
        uploadFileStatus: CONSTANTS.API.FAILED,
        uploadFileError: action.payload,
      };
    case ONBOARDING.UPDATE_PROGRESS:
      return {
        ...state,
        progress: Object.assign([], state.progress, { [action.payload.index]: action.payload.progress }),
      };
    case ONBOARDING.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE?.[action.payload] || null,
      };
    default:
      return state;
  }
};
